var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconBoxplotMax(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.625 0H9.375C9.72135 0 10 0.279379 10 0.626645V1.25329C10 1.60056 9.72135 1.87993 9.375 1.87993H0.625C0.278646 1.87993 0 1.60056 0 1.25329V0.626645C0 0.279379 0.278646 0 0.625 0ZM6.66667 11.0707V7.51974H8.95052C9.41406 7.51974 9.64583 6.95837 9.31771 6.62938L5.35677 2.65541C5.16146 2.45958 4.84115 2.45958 4.64583 2.65541L0.679688 6.62938C0.351562 6.95837 0.585938 7.51974 1.04948 7.51974H3.33333V11.0707C3.33333 11.418 3.61198 11.6974 3.95833 11.6974H6.04167C6.38802 11.6974 6.66667 11.418 6.66667 11.0707Z",
    fill: "#1E88E5"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBoxplotMax);
export default __webpack_public_path__ + "static/media/icon_boxplot_max.3032fe60730fd19442a7a9dad96601b8.svg";
export { ForwardRef as ReactComponent };